// API Configuration
// Use relative URL in production, or environment variable, or fallback to localhost for development
export const getApiBaseUrl = () => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  // In production, use relative URL
  if (process.env.NODE_ENV === 'production') {
    return '/api';
  }
  // Development fallback
  return 'http://localhost:5000/api';
};

export const API_BASE_URL = getApiBaseUrl();

// Log API URL for debugging
console.log('API_BASE_URL:', API_BASE_URL);
